/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník cílů úkolů.
 * @deprecated Nepoužívat, zůstává pouze pro potřeby zpětné kompatibility.
 * @enum {string}
 */
const TargetEnum = {
  PRIMARY: 'PRIMARY'
};

export default TargetEnum;
